// extracted by mini-css-extract-plugin
export default {"icon":"CountryDutiesTaxes_icon__lJPRy"};